<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <caja-mensual-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import CajaMensualProvider from "../../../../providers/CajaMensualProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import CajaMensualForm from "../CajaMensualForm";
    
    


    export default {
        name: "CajaMensualCreate",
         
        components: { CajaMensualForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.cajaMensual.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    fecha: null,
                    cerrada: false
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    CajaMensualProvider.createCajaMensual(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createCajaMensual)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

